<!--Roles and Rights For Promotions Starts-->
<div class="row">
  <div class="col-xl-12 col-lg-12 col-12">
    <div class="card mt-0 shopping-cart">
      <div class="card-header pb-2">
        <h4 class="card-title mb-1" translate="">lblManagePreferences</h4>
      </div>
      <div class="card-content">
        <div class="card-body">
          <div class="table-responsive tfixheader">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" translate>lblDealer</th>
                  <th scope="col" translate>lblActivatePreference</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="allDealerList && allDealerList?.length > 0; else load_else">
                  <tr *ngFor="let dealer of allDealerList;let i=index" style="cursor: pointer;">
                    <td>
                      {{ i+1 }}
                    </td>
                    <td>
                      <ngb-highlight [result]="dealer.dealerName"></ngb-highlight>
                    </td>
                    <td>
                      <div class="custom-switch custom-control-inline mb-1 mb-xl-0">
                        <ng-container>
                          <input [disabled]="!dealer.isDealerActive" type="checkbox"  class="custom-control-input" 
                            name="DiCheckBreak-{{i}}" id="DiCheckBreak-{{i}}" checked
                            [(ngModel)]="dealer.isActiveDealerForPreference" 
                            (click)="activeInactiveDealer($event, dealer.dealerId, dealer.isActiveDealerForPreference, content)"
                            />
                          <label class="custom-control-label mr-1" for="DiCheckBreak-{{i}}">
                            <span *ngIf="dealer.isActiveDealerForPreference" translate>lblYes</span>
                            <span *ngIf="!dealer.isActiveDealerForPreference" translate>lblNo</span>
                          </label>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_else>
                  <tr>
                    <td colspan="4"><span translate>lblNoRecordsFound</span></td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--Roles and Rights For Preferences Ends  -->

<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <div class="col-sm-3">
      <div class="flmid">
        <div class="input-group">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>

      </div>

    </div>
    <div class="col-sm-3 pl-4">
      <div class="relative">
      </div>
    </div>
    <div class="col-auto ml-auto">
      <button type="button" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate
        (click)="onAdd()">lblAddPreferences</button>
    </div>

  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblPreferences</h4>
        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" sortable="brand" (sort)="onSort($event)" translate>lblBrand</th>
                <th style="width: 20%" scope="col" translate>lblQuestion</th>
                <th style="width: 20%" scope="col" translate>lblDescription</th>
                <th style="width: 20%" scope="col" translate>lblAnswer</th>
                <th style="width: 10%" scope="col" translate>lblActive</th>
                <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="preferenceList?.length>0; else load_else">
                <tr *ngFor="let preference of preferenceList; let i=index">
                  <td>{{preference.rowNumber}}</td>
                  <td>
                    <ngb-highlight [result]="preference.brand" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="preference.question" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="preference.description" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="preference.answerInputs" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <div class='lbl-info'>
                      <div class="custom-control custom-switch">
                        <ng-container>
                          <input type="checkbox" class="custom-control-input" name="CheckBreak-{{i}}"
                            id="CheckBreak-{{i}}" [(ngModel)]="preference.isActive"
                            (click)="onActiveOrInactive(preference.id)" />
                          <label class="custom-control-label mr-1" for="CheckBreak-{{i}}">
                            <span *ngIf="preference.isActive" translate>lblYes</span>
                            <span *ngIf="!preference.isActive" translate>lblNo</span>
                          </label>
                        </ng-container>
                      </div>
                    </div>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(preference.id)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete" (click)="deletePreference(preference.id)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</div>
<!-- new theme implementation ends -->

<!-- pdf view-->



<ng-template #content let-modal>
  <div class="modal-style">
    <div class="modal-header">
      <em class="ft-alert-triangle font-medium-5" style="margin-top: 0.3rem;color: white;"></em>&nbsp;&nbsp;&nbsp;
      <p class="modal-title" style="margin-top: 0.3rem;color: white;" id="modal-basic-title">
        {{confrimationTitle}}
      </p>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('false')">
        <span aria-hidden="true">X</span>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-body-text">{{confrimationMessage}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.close(true)" translate>
        lblYes
      </button>
      <button type="button" class="btn btn-outline-dark" (click)="modal.close(false)" translate>
        lblCancel
      </button>
    </div>
  </div>
</ng-template>